//powershell
//$bytes = [Convert]::FromBase64String((get-content -raw $inFile))
//[IO.File]::WriteAllBytes('c:\x.png', $bytes)
MG.AWS = {
  albumBucketName : "p1-images",
  bucketRegion : "us-east-2",
  IdentityPoolId : "us-east-2:2877ceed-99b5-42a9-97e9-f07d5afba60c",
};

AWS.config.update({
  region: MG.AWS.bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: MG.AWS.IdentityPoolId
  })
});

var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: MG.AWS.albumBucketName }
});

MG['randomString'] = function (length) {
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    var i;
    var result = "";
    values = new Uint32Array(length);
    window.crypto.getRandomValues(values);
    for(i=0; i<length; i++){
      result += charset[values[i] % charset.length];
    }
    return result;
}
  
MG['b64toBlob'] = function (b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

MG['setCookie'] = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

MG['getCookie'] = function (cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

MG.AWS['checkLast'] = function () {
	var lastImage = MG.getCookie("lastLocation_" + MG.crop_width);
  	if (lastImage) {
    	image.src=lastImage;
      previewImg.src = lastImage;
      MG.cropper.setImgFileName(lastImage);
  	}
}

MG.AWS['uploadPhoto'] = function (imgTxtObj,objToClose,callback,imgSize) {
  if (imgTxtObj.value == "") { return; }
  var payload = MG.b64toBlob(imgTxtObj.value,"image/png");
  var albumName = "CustomImages";
  var albumPhotosKey = encodeURIComponent(albumName) + "/";
  var d = new Date();
  var fileName = "" + d.toISOString().substring(2, 10).replaceAll("-", "") + MG.randomString(4) + imgSize + ".png";
  //var fileName = 'p-' + (d.toISOString().substring(2, 10).replaceAll('-','')) + MG.randomString(4) + '.png';
  var photoKey = albumPhotosKey + fileName;

  var upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: MG.AWS.albumBucketName,
      Key: photoKey,
	  ContentEncoding: 'base64',
      Body: payload,
      ContentType: "image/png",
    }
  });

  var promise = upload.promise();

  promise.then(
    function(data) {
      //alert("Successfully uploaded photo.");
      //console.log(data);
      if (callback) { callback(data.Location);}
      if (objToClose) { objToClose.style.display = "none";}
      MG.setCookie("lastLocation_" + MG.crop_width,data.Location,110);
      console.log('Successful upload');
    },
    function(err) {
	  console.log(err);
      return alert("There was an error uploading your photo: ", err.message);
    }
  );
  return fileName;
}
